import React from "react";
import { Sparkles } from "lucide-react";

/**
 * BetaNotice — positive, intentional Beta messaging.
 *
 * Two visual variants, both driven by the same copy source of truth so we can
 * lift the whole component when Beta ends by deleting one file.
 *
 * variant="pill"      — hero pill/banner, single line
 * variant="detailed"  — pricing-page callout with full explanation
 *
 * Wording is intentionally NOT the word "trial" per product direction.
 */
export function BetaNotice({ variant = "pill" }) {
  if (variant === "pill") {
    return (
      <div
        data-testid="beta-notice-pill"
        className="inline-flex items-center gap-3 rounded-full border border-terracotta/40 bg-terracotta/5 pl-2 pr-4 py-1.5 mt-6 mb-2"
      >
        <span className="inline-flex items-center gap-1.5 rounded-full bg-terracotta/15 text-terracotta px-2.5 py-0.5 text-[10px] tracking-[0.18em] uppercase font-medium">
          <Sparkles className="w-3 h-3" strokeWidth={2} />
          Beta
        </span>
        <span className="text-xs sm:text-sm text-bone/75 leading-tight">
          ChronoVaults is currently in Beta · Early-user pricing available while we refine the experience.
        </span>
      </div>
    );
  }

  // variant === "detailed"
  return (
    <div
      data-testid="beta-notice-detailed"
      className="mt-10 mb-10 border border-terracotta/25 bg-terracotta/[0.04] rounded-sm p-6 sm:p-8"
    >
      <div className="flex items-center gap-3">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-terracotta/15 text-terracotta px-2.5 py-0.5 text-[10px] tracking-[0.18em] uppercase font-medium">
          <Sparkles className="w-3 h-3" strokeWidth={2} />
          Beta
        </span>
        <p className="label-mono text-terracotta">Beta pricing · early-user rates</p>
      </div>
      <h2 className="font-serif text-2xl sm:text-3xl text-bone mt-4 leading-tight">
        ChronoVaults is currently in Beta
      </h2>
      <div className="mt-4 space-y-3 text-sm text-white/70 max-w-3xl leading-relaxed">
        <p>
          You're using an early version of ChronoVaults while we continue refining the experience and adding new
          features.
        </p>
        <p>
          During this Beta period, our pricing is being kept intentionally low while we gather real-world feedback and
          improve the service.
        </p>
        <p>
          If you choose to use ChronoVaults during Beta, we'd genuinely value your feedback — it will help shape the
          final product.
        </p>
        <p className="text-bone/85">Thank you for being an early user.</p>
      </div>
    </div>
  );
}

export default BetaNotice;
